<script>
  import { urlParams, catalog } from '../base/store'
  import FilterRange from './FilterRange.svelte'
  import FilterValue from './FilterValue.svelte'
  import FilterCheckbox from './FilterCheckbox.svelte'
  import FilterCatalogTree from './FilterCatalogTree.svelte'
  import FilterSnippet from './FilterSnippet.svelte'

  let shortFilters, detailFilters
  $: ({ count: N="...", count_suffix: suffix="ий" } = ($catalog.data || {}).pagination || {})
// Event handlers
  const toggleFiltersMobile = e => {
    if (shortFilters.style.maxHeight){
      shortFilters.style.maxHeight = null;
    } else {
      shortFilters.style.maxHeight = shortFilters.scrollHeight + "px";
    } 
  }
  const showDetailFilters = e => detailFilters.classList.add('active')
  const hideDetailFilters = e => detailFilters.classList.remove('active')
  const clearAll = async e => { 
    urlParams.reset()
    await urlParams.applyFilters()
  }
</script>

<button class="button-filters__mobile" on:click={toggleFiltersMobile}>
  <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="22.5" cy="22.5" r="22" fill="#FFD876" stroke="#181818" />
    <path d="M12.4141 17.1079H33.3069" stroke="black" />
    <path d="M12.4141 27.8916H33.3069" stroke="black" />
    <circle cx="25.8934" cy="17.1082" r="3.54378" fill="#FFD876" stroke="#181818" />
    <circle cx="19.1532" cy="27.8919" r="3.54378" fill="#FFD876" stroke="#181818" />
  </svg>
  <p>
    Фильтры
  </p>
  <div class="active-filter__count">
    <p>
      3
    </p>
  </div>
</button>
<div class="filters-wrapper" bind:this={shortFilters}>
  <div class="inputs-row">
    <div class="input-wrapper">
      <label for="type">Тип сделки</label>
      <FilterSnippet key="deal_type" model="DealType"/>
    </div>
    <FilterCheckbox key="mortgage" text="Ипотека"/>
    <FilterCatalogTree/>
    <div class="input-wrapper">
      <label for="cost">Стоимость, тыс. руб.</label>
      <div class="cost-inner">
        <FilterRange key="price" factor=1000/>
      </div>
    </div>
  </div>
  <div class="inputs-row">
    <div class="input-row__inner">
      <div class="input-wrapper">
        <label for="cost">Площадь</label>
        <div class="cost-inner">
          <FilterRange key="living_area"/>
        </div>
      </div>
      <ul class="rooms-items">
        <li class="rooms-item">
          <FilterValue key="studio" value="true" text="Студия"/>
        </li>
        {#each [1, 2, 3].map(String) as rooms}
          <li class="rooms-item">
            <FilterValue key="rooms" value={rooms} text={rooms}/>
          </li>
        {/each}
        <li class="rooms-item">
          <FilterValue key="rooms" value={[4,5,6,7,8,9,10].map(String).join("++")} text="4+"/>
        </li>
      </ul>
    </div>
    <div class="buttons-row__filters">
      <button class="clear-filters" on:click={clearAll}>
        <div class="clear-filters__inner">
          <p>
            Очистить всё
          </p>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 9.46826L9.92941 9.46826" stroke="white" />
            <path
              d="M5.00249 1.32153C5.38888 0.935141 6.01536 0.935141 6.40174 1.32153L9.21021 4.12999C9.5966 4.51638 9.5966 5.14283 9.21021 5.52922L7.9742 6.76523L6.88464 7.85479H1.71113L0.789791 6.93345C0.403403 6.54706 0.403403 5.92061 0.789791 5.53423L3.65924 2.66477L5.00249 1.32153Z"
              stroke="white" />
          </svg>
        </div>
      </button>
      <button class="detail-button" on:click={showDetailFilters}>
        <p>
          Расширенный поиск
        </p>
        <span>
          +
        </span>
      </button>
    </div>
  </div>
</div>

<div class="popup-filters__wrapper" bind:this={detailFilters}>
  <div class="popup-filters__inner">
    <div class="popup-filters__wrapper-btn">
      <button class="close-filters__popup" on:click={hideDetailFilters}>
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L20.9999 20.9999" stroke="black" />
          <path d="M21 1L1.00005 20.9999" stroke="black" />
          <circle cx="11" cy="11" r="2.49999" fill="#FFCF54" />
        </svg>
      </button>
    </div>
    <div class="popup-filters-title">
      <h3>
        Поиск недвижимости
      </h3>
    </div>
    <div class="popup-filters__items">
      <div class="popup-filter__row">
        <div class="popup-filter__row-title">
          <p>
            Часто используемые
          </p>
        </div>
        <div class="popup-filter__inputs">
          <div class="popup-filter__input-wrapper">
            <label for="type">Тип недвижимости</label>
            <FilterSnippet key="realty_type" model="RealtyType"/>
          </div>
          <div class="popup-filter__input-wrapper">
            <label for="year">Год постройки</label>
            <div class="year-popup-wrapper">
              <FilterRange key="year"/>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-filter__row">
        <div class="popup-filter__row-title">
          <p>
            Квартиры
          </p>
        </div>
        <div class="popup-filter__inputs">
          <div class="popup-filter__input-wrapper">
            <label for="type">Отделка</label>
            <FilterSnippet key="decoration" model="Decoration"/>
          </div>
          <div class="popup-filter__input-wrapper">
            <label for="type">Мебель</label>
            <FilterSnippet key="furniture" model="Furniture"/>
          </div>
          <div class="popup-filter__input-wrapper">
            <label for="type">Санузел</label>
            <FilterSnippet key="bathroom" model="Bathroom"/>
          </div>
        </div>
      </div>
      <div class="popup-filter__row">
        <div class="popup-filter__inputs">
          <div class="popup-filter__input-wrapper">
            <label for="year">Высота потолков кв.м</label>
            <div class="year-popup-wrapper">
              <FilterRange key="ceiling"/>
            </div>
          </div>
          <div class="popup-filter__input-wrapper">
            <label for="year">Площадь кухни кв.м</label>
            <div class="year-popup-wrapper">
              <FilterRange key="kitchen_area"/>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-filter__row">
        <div class="popup-filter__row-title">
          <p>
            Дом
          </p>
        </div>
        <div class="popup-filter__inputs">
          <div class="popup-filter__input-wrapper">
            <label for="year">Этаж</label>
            <div class="year-popup-wrapper">
              <FilterRange key="storey"/>
            </div>
          </div>
          <div class="popup-filter__input-wrapper">
            <label for="year">Этажей в доме</label>
            <div class="year-popup-wrapper">
              <FilterRange key="storeys"/>
            </div>
          </div>
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="storey_not_first" text="Не первый"/>
          </div>
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="storey_last" value="false" text="Не последний"/>
            </div>
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="multi_level" text="Многоуровневая"/>
          </div>
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="storey_last" value="true" text="Только последний"/>
            </div>
        </div>
        <div class="popup-filter__inputs house-inputs">
          <div class="popup-filter__input-wrapper">
            <label for="type">Материал стен</label>
            <FilterSnippet key="construction_material" model="ConstructionMaterial"/>
          </div>
          <div class="popup-filter__input-wrapper">
            <FilterCheckbox key="lift" text="Лифт"/>
          </div>
        </div>
      </div>
      <div class="popup-filter__row">
        <div class="popup-filter__row-title">
          <p>
            Дополнительно
          </p>
        </div>
        <div class="popup-filter__inputs">
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="discount" text="Цена со скидкой"/>
          </div>
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="swap" text="Обмен"/>
          </div>
          <div class="popup-filter__input-wrapper chekbox-wrap">
            <FilterCheckbox key="has_image" text="С фото"/>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="popup-filter__row-footer">
    <button class="clear-popup__filter" on:click={clearAll}>
      <p>
        Очистить фильтр
      </p>
      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M-0.000976562 8.93652L9.92843 8.93652" stroke="white"/>
        <path d="M5.00151 0.789791C5.3879 0.403403 6.01438 0.403403 6.40077 0.789791L9.20923 3.59825C9.59562 3.98464 9.59562 4.61109 9.20923 4.99748L7.97322 6.23349L6.88366 7.32305H1.71015L0.788814 6.40171C0.402426 6.01533 0.402426 5.38888 0.788814 5.00249L3.65827 2.13303L5.00151 0.789791Z" stroke="white"/>
        </svg>        
    </button>
    <button class="show-results__popup" on:click={hideDetailFilters}>
      <p>
        Показать {N} предложен{suffix}
      </p>
      <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="3" width="5" height="5" rx="2.5" stroke="#181818"/>
        </svg>          
    </button>
  </div>
</div>
